import { css } from "@emotion/react"
import { ReactComponent as Cross } from "../../icons/cross.svg";
import { ReactComponent as Check } from "../../icons/check.svg";
import { weights } from "@upsun/react-component-library/src/styles";
import { useId } from "react";

type FeatureType = {
  title: string
  description: string
}

type FeatureListProps = {
  style: "cross" | "check"
  items: FeatureType[]
}

const FeatureList : React.FC<FeatureListProps> = ({style, items}) => {
  const featureListStyle = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    gap: 24px;
  `;

  const itemContainerStyle = css`
    text-align: left;
  `;

  const headerStyles = css`
    display: flex;
    justify-content: flex-start;
    align-items: center;

    gap: 18px;

    > span {
      font-weight: ${weights.bold};
    }
  `;

  const randomId = useId();

  return(
    <div css={featureListStyle}>
      {
        items.map((item, index) => (
          <div css={itemContainerStyle} key={`featureList-${randomId}-${index}`}>
            <div css={headerStyles}>
              {style === "check" && <Check />}
              {style === "cross" && <Cross />}
              <span>{item.title}</span>
            </div>
            <div css={css`padding-left: 32px;`}>{item.description}</div>
          </div>
        ))
      }
    </div>
  );
}

export default FeatureList;